<mat-dialog-content>
  <p class="title">{{ 'login.logout_title' | i18nextEager }}</p>
  <p>{{ 'login.logout_subtitle' | i18nextEager }}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <bdeo-button type="danger" [text]="'Cancelar'" (click)="onNoClick()" tabindex="1"></bdeo-button>
  <bdeo-button
    type="primary"
    [text]="'Aceptar'"
    (click)="onYesClick()"
    tabindex="2"
    [icon]="loading ? 'loading-circle' : ''"
    [disabled]="loading"
  ></bdeo-button>
</mat-dialog-actions>
